import { resolveIcon } from "@/cms/icons";

const DEFAULT_VALUES = [
  {
    icon: "Trophy",
    title: "Premium Quality",
    desc: "We partner only with the world's finest courses and resorts, ensuring every round exceeds expectations.",
  },
  {
    icon: "Leaf",
    title: "Sustainable Tourism",
    desc: "Every booking supports eco-conscious courses and local communities, preserving the fairways for generations.",
  },
  {
    icon: "Globe",
    title: "Global Reach",
    desc: "From Batam to Bali, Bangkok to Hua Hin — we unlock exclusive tee times across Asia and beyond.",
  },
  {
    icon: "Users",
    title: "Dedicated Concierge",
    desc: "Our team handles every detail — flights, hotels, transfers, and tee times — so you can focus on your game.",
  },
];

export default function AboutValues({ fields = {} }) {
  const {
    eyebrow = "What We Stand For",
    headline = "Our Core Values",
    values = DEFAULT_VALUES,
  } = fields;

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white/5">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-3">
            {eyebrow}
          </p>
          <h2 className="text-white font-bold text-3xl sm:text-4xl">{headline}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v, i) => {
            const Icon = resolveIcon(v.icon);
            return (
              <div
                key={i}
                className="bg-white/5 border border-white/10 rounded-2xl p-6"
              >
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-[#D4AF37]" />
                </div>
                <h3 className="text-white font-semibold text-base mb-2">
                  {v.title}
                </h3>
                <p className="text-white/50 text-sm leading-relaxed">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
